
import {Options, Vue} from "vue-class-component";
import LeiDetails from "@/components/base/lei-details.vue";
import {leiStorageModule} from "@/store/lei-storage";
import {Lei} from "@/store/model";

@Options({
  components: {
    LeiDetails
  }
})
export default class LeiDashboardDetails extends Vue {

  lei!: Lei;

  created(){
    this.lei = leiStorageModule.getLeis.find(item => item.registrationDetails.lei === this.$route.params.id.toString()) as Lei;
  }
}
